import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-plan-goal-setting-form',
  templateUrl: './review-plan-goal-setting-form.component.html',
  styleUrls: ['./review-plan-goal-setting-form.component.scss']
})
export class ReviewPlanGoalSettingFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
